import React from "react";
import { Button } from "../button";
import { DropdownMenuTrigger as DropdownMenuTriggerUI } from "../dropdown-menu";

interface DropdownMenuTriggerProps {
  icon?: React.ReactNode;
  label?: string;
}

export const DropdownMenuTrigger = ({
  icon,
  label,
}: DropdownMenuTriggerProps) => {
  return (
    <DropdownMenuTriggerUI
      hideChevron
      size="sm"
      className="border-0 p-0 shadow-none group-hover:bg-gray-50"
    >
      <Button size="icon" variant="ghost" onClick={(e) => e.stopPropagation()}>
        {icon}
        {label && <span className="ml-2">{label}</span>}
      </Button>
    </DropdownMenuTriggerUI>
  );
};
